import type { ActionFunction } from '@remix-run/node';
import type { SetDirectoryFeaturedProjectMutationVariables } from 'generated/graphql';
import { setDirectoryFeaturedProject } from '~/modules/directory/api/set-directory-featured-project.server';
import { z } from 'zod';
import * as zfd from 'zod-form-data';
import { UserErrorResponse } from '~/modules/root/graphql/responses';

const SetFeaturedProjectInputSchema = z.object({
    projectID: zfd.numeric(z.number()),
    feature: z.string(),
});

export const action: ActionFunction = async ({ request, context }) => {
    const formData = await request.formData();
    const zfdFormData = zfd.formData(SetFeaturedProjectInputSchema);
    const zfdResult = zfdFormData.safeParse(formData);
    if (!zfdResult.success) {
        throw new UserErrorResponse(zfdResult.error);
    }
    const variables: SetDirectoryFeaturedProjectMutationVariables = {
        ProjectID: zfdResult.data.projectID,
        Feature: zfdResult.data.feature === 'true',
    };

    return await setDirectoryFeaturedProject({
        ...context,
        ...variables,
    });
};

export const SET_FEATURED_PROJECT = '/remix-api/directory/set-featured-project';
